import { HTMLProps, useState } from "react";

import ImageDetails from "../../styles/components/ImageDetails";
import Skeleton from "../utils/Skeleton.component";

export interface ImageProps extends HTMLProps<HTMLImageElement> {
  data?: any;
  width: string;
  height: string;
}

const Image = ({ data, width, height, ...rest }: ImageProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const onLoad = () => {
    setImageLoaded(true);
  };

  return (
    <ImageDetails $width={width} $height={height}>
      {!imageLoaded && (
        <Skeleton
          style={{ position: "absolute" }}
          width={width}
          height={height}
        />
      )}
      <img {...rest} onLoad={onLoad} alt={rest.alt} />
    </ImageDetails>
  );
};

export default Image;
